import type { JSX } from "react";
import { Navigate, useLocation } from "react-router";

/**
 * `/settings/channels` → `/sozlamalar?section=channels`, keeping the query. Kanallar lives
 * inside Sozlamalar, and the Meta consent callback names the old path; this keeps that
 * link working and carries its `instagram=…` outcome to the card.
 */
export function ChannelsRedirect(): JSX.Element {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  params.set("section", "channels");
  return <Navigate to={{ pathname: "/sozlamalar", search: `?${params.toString()}` }} replace />;
}
